// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_popper.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import lazyframe from 'lazyframe';
import AOS from 'aos';

// Migrate existing consent from localStorage to sessionStorage
(function ($) {
  $(document).ready(function() {
    const existingConsent = window.localStorage.getItem('consent');
    if (existingConsent) {
      window.sessionStorage.setItem('consent', existingConsent);
      window.localStorage.removeItem('consent');
      console.log('Migrated existing consent to session storage');
    }
  });
})(jQuery);

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

(function ($) {
  lazyframe($('iframe'));
  lazyframe($('img'));
})(jQuery);

// Stop Scroll
(function ($) {
  $(document).scrollTop(0);
  $('html, body').css({
    overflow: 'hidden',
    height: '100%',
  });
})(jQuery);

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Enable bootstrap popover
(function ($) {
  $('[data-toggle="popover"]').popover();

  $(window).on('scroll', () => {
    $('[data-toggle="popover"]').popover('hide');
  });
})(jQuery);

// Enforce consent with UTM parameter preservation
// Enforce consent with UTM parameter preservation
(function ($) {
  $(document).ready(() => {
    // Function declared at the root level to avoid ESLint issues
    function redirectToHome(pathname, searchParams) {
      window.sessionStorage.setItem('pathname', pathname + searchParams); // Store path with UTM parameters
      window.location = '/';
    }

    // eslint-disable-next-line no-undef
    if (enforce_consent) {
      // Check both localStorage (legacy) and sessionStorage (new) for consent
      let consent = window.sessionStorage.getItem('consent') || window.localStorage.getItem('consent');
      let pathname = window.location.pathname;
      let searchParams = window.location.search; // Get UTM parameters if any

      // eslint-disable-next-line no-undef
      let exceptions = consent_exceptions;

      // Check consent and redirect if necessary
      if (!consent && pathname !== '/' && !exceptions.includes(pathname)) {
        redirectToHome(pathname, searchParams);
      } else if (!pathname.startsWith('/' + consent) && pathname !== '/' && !exceptions.includes(pathname)) {
        // Invalidate the consent in both storages
        window.localStorage.removeItem('consent');
        window.sessionStorage.removeItem('consent');
        redirectToHome(pathname, searchParams);
      }

      // HCP consent handler
      $('.consent-hcp a').on('click', function (e) {
        e.preventDefault();

        var popupMarkup = `
          <div id="hcpPopupWrapper" class="popup">
            <div class="overlay" style="width: 100%; height: 100%;z-index: 998;background: #0006;position: fixed;">&nbsp;</div>
            <div id="hcpPopup" style="display: none; border-radius: 8px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: #fff; padding: 4em; border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);z-index: 999">
              <strong class="d-block pt-2 pb-3" style="font-size: 18px">Are you a healthcare professional?</strong>
              <p>This promotional website is intended solely for UK and Ireland healthcare professionals. Please confirm below.</p>
              <div id="yesButton" class="wp-block-button is-style-outline text-center pt-3 mb-2"><a class="has-text-color has-background" href="#" style="display:block;line-height: 1;padding: 1em .9em; border: 2px solid; border-radius:6px; background-color:#563D82; color:#fff">I am a healthcare professional in the UK or Ireland</a></div>
              <div id="noButton" class="wp-block-button is-style-outline text-center pb-3"><a class="has-white-background-color has-text-color has-background" href="#" style="display:block;line-height: 1;padding: 1em .9em; border: 2px solid; border-radius:6px; color:#2E3233">No, take me back to the audience selector</a></div>
              <small class="d-block text-center pt-3">IE-NEO-2400199 | December 2024</small>
            </div>
            <style type="text/css"> #hcpPopup {
              width: 650px;
            } @media screen and (max-width: 1023px) {
             #hcpPopup {
             width: calc(100% - 20px) !important;
             }
            }</style>
          </div>
        `;

        $('body').prepend(popupMarkup);
        $('html, body').css('overflow', 'hidden');

        $('#hcpPopup').show();

        $('#yesButton').on('click', function () {
          window.sessionStorage.setItem('consent', 'hcp');

          let storedPath = window.sessionStorage.getItem('pathname');
          window.sessionStorage.removeItem('pathname');

          // Redirect with UTM parameters if available
          window.location = storedPath ? storedPath : e.target.href;
        });

        $('#noButton').on('click', function () {
          $('#hcpPopupWrapper').remove();
          $('html, body').css('overflow', 'auto');
        });
      });

      // Patients consent handler
      $('.consent-patients a').on('click', function (e) {
        e.preventDefault();
        window.sessionStorage.setItem('consent', 'patients');

        let storedPath = window.sessionStorage.getItem('pathname');
        window.sessionStorage.removeItem('pathname');

        window.location = storedPath ? storedPath : (e.target.href || '/patients/');
      });

      // Smooth scroll to .page-footer when #pre-header-linked is clicked
      $('#pre-header-linked').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $('.footer__logo').offset().top - 35,
        }, 900);
      });


      // Select the specific image by class or other selector and remove the ttitle on click
      $('.responsive-image--3070541f-214d-47fc-baa0-2d0f2fa06d64, .responsive-image--531a8c54-194c-43ae-adac-3a0ceb968bc5, img').on('mouseenter', function () {
        // Temporarily remove the title on hover
        $(this).data('title', $(this).attr('title')).removeAttr('title');
      }).on('mouseleave', function () {
        // Restore the title after hover
        $(this).attr('title', $(this).data('title'));
      });

      // Public consent handler
      $('.consent-public a').on('click', function (e) {
        e.preventDefault();
        window.sessionStorage.setItem('consent', 'public');

        let storedPath = window.sessionStorage.getItem('pathname');
        window.sessionStorage.removeItem('pathname');

        window.location = storedPath ? storedPath : (e.target.href || '/public/');
      });
    }
  });
})(jQuery);


/**
 * Required to make tabs active for a split second
 * to calculate heights. Should appear before justify-*
 * classes
 */
(function ($) {
  $('.tabbed-pages .tab-pane').each((i, v) => {
    $(v).addClass('active')
  });

  setTimeout(() => {
    $('.tabbed-pages .tab-pane').each((i, v) => {
      i !== 0 ? $(v).removeClass('active') : ''
    });
  }, 100)
})(jQuery);

/*
 * Each paragraph's height that doesn't have class will be equaled
 * Each paragrap's height that has identical first class will be equaled
 */
(function ($) {
  $(document).ready(function () {
    if ($(window).innerWidth() > 991) {
      let justifyParagraphs = $('.justify-paragraphs>div')
      justifyParagraphs.each((i, justifyParagraph) => {
        let pTags = $(justifyParagraph).find('p');
        let classes = [];

        pTags.each(function () {
          if ($(this).attr('class') !== undefined) {
            classes.push($(this).attr('class').split(' ')[0])
          }
        });

        classes = classes.filter((x, y, z) => z.indexOf(x) === y).filter(e => e).map(e => '.' + e);
        classes.push('p:not([class!=\'\'])');

        classes.forEach(function (e) {
          let maxHeight = 0;
          let elems = $(justifyParagraph).find($(e))
          elems.each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight())
          });

          if (maxHeight > 0) {
            if ($(justifyParagraphs).hasClass('v-center')) {
              elems.each(function () {
                var $this = $(this);
                $this.wrap('<span style="display: flex; align-items: center; height: ' + maxHeight + 'px;"></span>');
              });
            } else {
              elems.outerHeight(maxHeight);
            }
          }
        })
      })
    }
  })
})(jQuery);

/*
 * Each list's height that doesn't have class will be equaled
 * Each list's height that has identical first class will be equaled
 */
(function ($) {
  $(document).ready(function () {
    if ($(window).innerWidth() > 991) {
      let justifyLists = $('.justify-lists>div')

      justifyLists.each((i, justifyList) => {
        let ulTags = $(justifyList).find('ul');
        let classes = [];

        ulTags.each(function () {
          if ($(this).attr('class') !== undefined) {
            classes.push($(this).attr('class').split(' ')[0])
          }
        });

        classes = classes.filter((x, y, z) => z.indexOf(x) === y).filter(e => e).map(e => '.' + e);
        classes.push('ul:not([class=\'\'])');

        classes.forEach(function (e) {
          let maxHeight = 0;
          let elems = $(justifyList).find($(e))
          elems.each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight())
          });

          if (maxHeight > 0) {
            if ($(justifyList).hasClass('v-center')) {
              elems.each(function () {
                var $this = $(this);
                $this.wrap('<span style="display: flex; align-items: center; height: ' + maxHeight + 'px;"></span>');
              });
            } else {
              elems.outerHeight(maxHeight);
            }
          }
        })
      })
    }
  })
})(jQuery);

/*
 * Justify simple-card elements
 */
(function ($) {
  $(document).ready(function () {
    if ($(window).innerWidth() > 991) {
      let justifyCards = $('.justify-cards>div');

      justifyCards.each(function () {
        let maxHeight = 0;
        let cards = $(this).find('> div > div');

        cards.each(function () {
          maxHeight = Math.max(maxHeight, $(this).outerHeight())
        });

        if (maxHeight > 0) {
          cards.outerHeight(maxHeight);
        }
      });
    }
  })
})(jQuery);

/*
 * Make menu visible if is the current page
 */
(function ($) {
  function getLastPart(url) {
    if (url) {
      const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
      const parts = cleanUrl.split('/');
      return parts.length >= 2 ? parts[parts.length - 2] : null;
    }
    return null;
  }

  function checkLastPart(part) {
    const currentUrl = window.location.href;
    return currentUrl.includes(part);
  }

  if (window.outerWidth >= 768) { // Exclude screens smaller than 768px
    $('#menu-hcp-main-menu .menu-item .dropdown-menu .menu-item').each((index, elem) => {
      if ((getLastPart($(elem).find('a').attr('href')) === 'curosurf' || getLastPart($(elem).find('a').attr('href')) === 'peyona') && checkLastPart(getLastPart($(elem).find('a').attr('href')))) {
        $(elem).addClass('active');
        $(elem).addClass('current_page_item');
        $(elem).parent('.dropdown-menu').addClass('show');
        $(elem).parent().parent('.menu-item').addClass('active');
        $(elem).parent().parent('.menu-item').addClass('current-menu-parent');
      }
    });

    let currentMenuParent = $('.current-menu-parent');
    currentMenuParent.children('.nav-link').attr('aria-expanded', 'true');
    currentMenuParent.children('.dropdown-menu').addClass('show');
    currentMenuParent.addClass('show');

    $('#navbarSupportedContent').on('mouseenter', function () {
      currentMenuParent.children('.nav-link').attr('aria-expanded') ? currentMenuParent.children('.nav-link').attr('aria-expanded', 'false') : '';
      currentMenuParent.children('.dropdown-menu').hasClass('show') ? currentMenuParent.children('.dropdown-menu').removeClass('show') : '';
      currentMenuParent.hasClass('show') ? currentMenuParent.removeClass('show') : '';
    });

    let menuItem = $('.menu-item');
    menuItem.on('click', function () {
      currentMenuParent.children('.nav-link').attr('aria-expanded', 'false');
      currentMenuParent.children('.dropdown-menu').removeClass('show');
      currentMenuParent.removeClass('show');
    });

    if (window.outerWidth > 991) {
      let banner = $('.banner.header');
      if ($('.dropdown-menu').hasClass('show')) {
        banner.css('height', 150);
      }

      menuItem.on('mouseenter', function () {
        if ($(this).find('.dropdown-menu').length) {
          banner.css('height', 150);
        }
      });

      menuItem.on('mouseleave', function () {
        let dropdown = $(this).find('.dropdown-menu');
        if (dropdown.length && !dropdown.hasClass('show')) {
          banner.css('height', 84);
        }
      });
    }
  }
})(jQuery);

/*
 * Make parent menu item clickable
 */
(function ($) {
  let dropdown = $('.dropdown-toggle');
  dropdown.unbind().on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.offsetX > dropdown.find('span').width()) {
        $(this).attr('aria-expanded') ? $(this).attr('aria-expanded', 'false') : $(this).attr('aria-expanded', 'true');
        $(this).next('.dropdown-menu').hasClass('show') ? $(this).next('.dropdown-menu').removeClass('show') : $(this).next('.dropdown-menu').addClass('show');
        $(this).parent('.dropdown').hasClass('show') ? $(this).parent('.dropdown').removeClass('show') : $(this).parent('.dropdown').addClass('show');
      } else {
        window.location = $(this).attr('href');
      }
    }
  );
})(jQuery);

/* To wrap anchors around buttons if linked */
(function ($) {
  $('.anchor-inside:has(a)').each(function () {
    const anchor = $(this).find('a');
    const newAnchor = $('<a>').html('');
    const attributes = anchor.get(0).attributes;
    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];
      newAnchor.attr(attr.name, attr.value);
    }

    $(this).wrap(newAnchor)
    $(this).parent().css('color', 'inherit');
    $(this).find('a').css('color', 'inherit');
  });
})(jQuery);

// For tabs

(function (jQuery) {
  jQuery('.tabs-group .simple-card--copy:has(a)').each(function () {
    const anchor = jQuery(this).find('a');
    const href = anchor.attr('href');
    jQuery(this).closest('.simple-card').on('click', function () {
      window.location.href = href;
    });
    jQuery(this).closest('.simple-card').css('cursor', 'pointer');
  });
})(jQuery);

/* Videos */
(function ($) {
  $('video').each(function () {
    $(this).next('.icon').on('click', function () {
      let video = $(this).prev('video');
      video[0].play();
      video.attr('controls', true);
      video.attr('controlsList', 'nodownload');
      $(this).addClass('hide');
    });

    $(this).on('pause', function () {
      let icon = $(this).next('.icon');
      icon.removeClass('hide');
      $(this).attr('controls', false)
    });
  });
})(jQuery);

/* Video Container Background */
(function ($) {
  $('video').each(function () {
    let video = $(this)[0];
    let canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');

    extractColorFromVideoOnce();
    video.addEventListener('playing', extractColorFromVideo);

    function extractColorFromVideo() {
      if (!video.paused && !video.ended) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        let averageColor = getAverageColor(ctx);
        $(video).parent().css('background-color', averageColor);

        requestAnimationFrame(extractColorFromVideo);
      }
    }

    function extractColorFromVideoOnce() {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let averageColor = getAverageColor(ctx);
      $(video).parent().css('background-color', averageColor);
    }

    function getAverageColor(context) {
      if (canvas.width > 0 && canvas.height > 0) {
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height).data;
        const pixelCount = imageData.length / 4; // Each pixel has 4 values (RGBA)

        // Initialize variables to store the total color values
        let totalRed = 0;
        let totalGreen = 0;
        let totalBlue = 0;

        // Loop through each pixel and sum up the color values
        for (let i = 0; i < pixelCount; i++) {
          const offset = i * 4; // Each pixel has 4 values (RGBA)
          totalRed += imageData[offset];
          totalGreen += imageData[offset + 1];
          totalBlue += imageData[offset + 2];
        }

        // Calculate the average color values
        const averageRed = Math.floor(totalRed / pixelCount);
        const averageGreen = Math.floor(totalGreen / pixelCount);
        const averageBlue = Math.floor(totalBlue / pixelCount);

        // Return the average color as a CSS-formatted RGB string
        return `rgb(${averageRed}, ${averageGreen}, ${averageBlue})`;
      }
    }
  });
})(jQuery);

// Resume scroll
(function ($) {
  $('.play-video').on('click', function () {
    $(this).closest('video')[0].play();
  });
})(jQuery);

// Resume scroll
(function ($) {
  $(window).load(function () {
    $('.smooth-load').addClass('fade-out');
    $('html, body').css({
      overflow: 'auto',
      height: 'auto',
    });
  })
})(jQuery);

// Scroll next
(function ($) {
  $('.scroll-next').click(function () {
    var parent = $(this).closest('.main > *');
    var nextSibling = parent.next();
    $('html, body').animate({
      scrollTop: nextSibling.offset().top - 80,
    }, 1000);
  });
})(jQuery);


// Initialise AOS and refresh on nav-link click
(function ($) {
  if (typeof AOS === 'object') {
    AOS.init();
  }

  $('.nav-link').on('click', function () {
    if (typeof AOS === 'object') {
      setTimeout(() => {
        AOS.refresh()
      }, 300)
    }
  });

// Smooth scroll internal anchors
  $(document).ready(function () {
    $('a[href^="#"]').click(function (e) {
      e.preventDefault();

      var target = $(this).attr('href');
      var targetElement = $('.jump-to-' + target.replace('#', ''));

      if (targetElement.length > 0) {
        var targetOffset = targetElement.offset().top;
        $('html, body').animate({
          scrollTop: targetOffset - 180,
        }, 500);
      }
    });
  });

  $(window).load(function () {
    $('.plyr').each(function () {
      if (typeof Plyr !== 'function') {
        var swiperCdnUrl = 'https://cdn.plyr.io/3.7.8/plyr.polyfilled.js';
        var script = document.createElement('script');
        script.src = swiperCdnUrl;
        script.onload = function () {
          // eslint-disable-next-line
          const players = Array.from(document.querySelectorAll('.plyr')).map((p) => new Plyr(p));
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.plyr.io/3.7.8/plyr.css';

        document.head.appendChild(link);
        document.head.appendChild(script);
      }

    })
  })
})(jQuery)



// WEBPACK FOOTER //
// ./scripts/main.js